<template>
  <div>
    <el-upload :action="dataObj.host"
               :data="dataObj"
               list-type="picture"
               accept="image/*"
               ref="upload"
               :multiple="true"
               :show-file-list="showFileList"
               :before-upload="beforeUpload"
               :on-remove="handleRemove"
               :on-success="handleUploadSuccess"
               :on-preview="handlePreview"
               :limit="maxCount"
               :on-exceed="handleExceed">
      <el-button size="small"
                 type="primary"
                 style="float: right;">上传图片</el-button>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%"
           :src="dialogImageUrl">
    </el-dialog>
  </div>
</template>
<script>
import { policy } from '@/api/oss'
import md5 from 'js-md5'

export default {
  name: 'multiUpload',
  props: {
    //图片属性数组
    value: Array,
    //最大上传图片数量
    maxCount: {
      type: Number,
      default: 5
    },
    showList: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      dataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: 'https://haihaigo.oss-cn-shenzhen.aliyuncs.com'
      },
      dialogVisible: false,
      dialogImageUrl: null
    };
  },
  computed: {
    fileList () {
      let fileList = [];
      for (let i = 0; i < this.value.length; i++) {
        fileList.push({ url: this.value[i] })
      }
      return fileList
    },
    showFileList: {
      get: function () {
        return this.value !== null && this.value !== '' && this.value !== undefined && this.showList
      },
      set: function (newValue) {
      }
    }
  },
  methods: {
    removeItem (index) {
      this.$refs.upload.uploadFiles.splice(index, 1)
    },
    emitInput (fileList) {
      let value = [];
      for (let i = 0; i < fileList.length; i++) {
        value.push(fileList[i].url)
      }
      this.$emit('input', value)
    },
    handleRemove (file, fileList) {
      this.emitInput(fileList)
    },
    handlePreview (file) {
      this.dialogVisible = true
      this.dialogImageUrl = file.url
    },
    beforeUpload (file) {
      let _self = this
      // 最大只能上传2M文件
      if (file.size > 2097152) {
        this.$message.error('上传失败，最大只能上传2M大小的图片')
        return false
      }
      return new Promise((resolve, reject) => {
        policy().then(response => {
          _self.dataObj.policy = response.data.policy
          _self.dataObj.signature = response.data.signature
          _self.dataObj.ossaccessKeyId = response.data.accessKeyId
          _self.dataObj.key = response.data.dir + '/' + file.uid + md5(file.name)
          _self.dataObj.dir = response.data.dir
          _self.dataObj.host = response.data.host
          resolve(true)
        }).catch(err => {
          console.log(err)
          reject(false)
        })
      })
    },
    handleUploadSuccess (res, file) {
      this.showFileList = this.showList
      this.fileList.push({
        name: file.uid + md5(file.name),
        url: this.dataObj.host + '/' + this.dataObj.dir + '/' + file.uid + md5(file.name)
      })
      this.emitInput(this.fileList)
    },
    handleExceed (files, fileList) {
      this.$message({
        message: '最多只能上传' + this.maxCount + '张图片',
        type: 'warning',
        duration: 1000
      })
    }
  }
}
</script>
<style>
</style>





// WEBPACK FOOTER //
// src/components/Upload/multiUpload.vue